import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-09/task-01";

const task: Slide = {
  titleHtml:
    "Choose the correct magnet configuration that gives the Lorentz force F<sub>L</sub> depicted in the figure.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
